import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Select, Button } from '@gpstrackit/gtc-react-controls';
import { assignStatusesToEvent, assignStatusesToEventBulk, closeModalAssignStatus, searchStatuses, reset } from './redux/slice';
import { updateEventAssignStatus, updateEventAssignStatusBulk } from '../../redux/slice';
import { NotificationManager } from 'Components/Notifications';
import { checkDeviceData } from 'Core/data/Helpers'

const AssignStatusModal = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    
    const open = useSelector(state => state?.driverPerformanceEventsTabAssignStatusSliceRedux?.open);
    const lan = useSelector(state => state.commomRedux.language);
    const event = useSelector(state => state?.driverPerformanceEventsTabAssignStatusSliceRedux?.event);
    const loading = useSelector(state => state?.driverPerformanceEventsTabAssignStatusSliceRedux?.loading);
    const statuses = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.statuses);
    const loadingStatuses = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.loading);
    const savedStatus = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.savedStatus);
    const error = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.error);
    const multipleEvents = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.multipleEvents);
    const events = useSelector((state) => state.driverPerformanceEventsTabAssignStatusSliceRedux.events);

    const [status, setStatus] = useState(null);

    useEffect(() => {
        dispatch(searchStatuses());
    }, []);

    useEffect(() => {
        if(savedStatus || error){
            if(error){
                NotificationManager.warning(
                    messages["driver_performance_events_assingStatus_error"],
                    messages["warning"],
                    3000,
                    null,
                    null,
                    "info"
                )
            }else if(savedStatus?.success){
                NotificationManager.success(
                    messages['driver_performance_events_assingStatus_success'],
                    messages["success"],
                    3000,
                    null,
                    null,
                    "success"
                )
                if(multipleEvents){
                    //update status on event list for multiple events
                    dispatch(updateEventAssignStatusBulk({
                        events: events,
                        status: status
                    }));
                }else{
                    //update status on event list
                    dispatch(updateEventAssignStatus({
                        rowId: event?.rowId,
                        status: status,
                        esn: event?.esn
                    }));
                }
            }
            dispatch(reset());
            dispatch(closeModalAssignStatus());
        }
    }, [savedStatus]);

    useEffect(() => {
        if (!open) return;

        const sourceEvent = event ?? (events?.length === 1 ? events[0] : null);
        if (!sourceEvent) return;

        try {
            const deviceData = checkDeviceData(sourceEvent?.deviceData || '{}');
            const caseEventStatus = deviceData?.caseEventStatus;
            if (!caseEventStatus) return;

            let option = statuses?.find((statusItem) => statusItem.entityId === caseEventStatus) || null;

            if (option) {
                option = {
                    ...option,
                    label: messages[`driver_performance_${option.entityId}`] || option.label
                };  
            }

            setStatus(option);
        } catch (error) {
            // ignore invalid deviceData
        }
    }, [event, statuses, events, open]);

    const handleSubmit = () => { 

        if(multipleEvents){
            //update status on event list for multiple events
            dispatch(assignStatusesToEventBulk({
                status: status,
                events: events
            }));
            return;
        }
        dispatch(assignStatusesToEvent({
            rowId: event?.rowId,
            status: status,
            esn: event?.esn
        }));
    };

    return (
        <Modal
            open={open || false}
            handleClose={() => dispatch(closeModalAssignStatus())}
            loading={loading}
            title={messages['driver_performance_events_assingStatus_title']}
            position="right"
            size="small"
            closeButton={true}
            footer={
                <div>
                    <Button 
                        variant="secondary" 
                        style={{ marginRight: 8 }} 
                        onClick={() => dispatch(closeModalAssignStatus())}
                        >
                        {messages['cancel']}
                    </Button>
                    <Button 
                        variant="primary" 
                        isDisabled={loading || !status} 
                        onClick={(e) => { 
                            e.preventDefault();    
                            handleSubmit()
                        }}
                        >
                            {messages['update']}
                    </Button>
                </div>
            }
            >
            <div style={{ padding: 20 }}>
                <Select
                    id="status"
                    //queue for coaching (coachnow)
                    options={(statuses || []).map((item) => ({ ...item, label: messages[`driver_performance_${item.entityId}`] || item?.label })).filter(status => ["falsepositive", "noissue", "verified","highlightcoaching"].includes(status.entityId))}
                    textField="label"
                    valueField="entityId"
                    label={messages['driver_performance_events_assingStatus_status']}
                    placeholder={messages['driver_performance_events_assingStatus_selectStatus']}
                    value={status}
                    onChange={(value) => {
                        setStatus(value);
                    }}
                    isLoading={loadingStatuses}
                />
            </div>
        </Modal>
    );
};

export default AssignStatusModal;